import { Card, Row, Col, Typography } from "antd";
import { DollarCircleTwoTone, CheckCircleTwoTone, MinusCircleTwoTone } from "@ant-design/icons";

const { Text } = Typography;

export default function VerificacionPagosOverview({ totalMontoVerificaciones, totalMontoPagado, totalBalance }) {
  const valueStyle = { fontWeight: 500, fontSize: "1rem", textAlign: "right", color: "#444" };
  const labelStyle = { color: "#666", fontSize: "0.9rem" };
  const cardStyle = { borderRadius: 8, background: "#fff", border: "1px solid #f0f0f0" };

  return (
    <Row gutter={[16, 16]} style={{ marginBottom: 24 }} justify="start">
      <Col xs={24} sm={8} style={{ maxWidth: 280, flex: "1 1 240px" }}>
        <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
          <Row align="middle" justify="space-between">
            <Col>
              <DollarCircleTwoTone twoToneColor="#1890ff" style={{ fontSize: 20 }} />
              <Text style={labelStyle}>&nbsp;Monto Total</Text>
            </Col>
            <Col>
              <Text style={valueStyle}>${totalMontoVerificaciones.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col xs={24} sm={8} style={{ maxWidth: 280, flex: "1 1 240px" }}>
        <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
          <Row align="middle" justify="space-between">
            <Col>
              <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 20 }} />
              <Text style={labelStyle}>&nbsp;Monto Pagado</Text>
            </Col>
            <Col>
              <Text style={valueStyle}>${totalMontoPagado.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
            </Col>
          </Row>
        </Card>
      </Col>

      <Col xs={24} sm={8} style={{ maxWidth: 280, flex: "1 1 240px" }}>
        <Card style={cardStyle} bordered={false} bodyStyle={{ padding: "12px 16px" }}>
          <Row align="middle" justify="space-between">
            <Col>
              <MinusCircleTwoTone twoToneColor="#ff4d4f" style={{ fontSize: 20 }} />
              <Text style={labelStyle}>&nbsp;Saldo Pendiente</Text>
            </Col>
            <Col>
              <Text style={valueStyle}>${totalBalance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</Text>
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
}
